import gql from "graphql-tag";

import { boundary } from "api/boundary";

import { CHAT_DETAILS_FRAGMENT } from "./fragments";

export const ASSIGN_CHAT = {
  query: gql`
    mutation assignChat($organisationUuid: ID!, $numberUuid: ID!, $chatUuid: ID!, $accountUuid: ID) {
      assignChat(
        organisationUuid: $organisationUuid
        numberUuid: $numberUuid
        chatUuid: $chatUuid
        accountUuid: $accountUuid
      ) {
        ...ChatDetails
      }
    }

    ${CHAT_DETAILS_FRAGMENT.query}
  `,
  parse: boundary({
    assignChat: CHAT_DETAILS_FRAGMENT.parse,
  }),
};

export const UPDATE_CHAT_STATE = {
  query: gql`
    mutation updateChatState($numberUuid: ID!, $chatUuid: ID!, $state: ChatState!, $assignToAccountUuid: ID) {
      updateChatState(
        numberUuid: $numberUuid
        chatUuid: $chatUuid
        state: $state
        assignToAccountUuid: $assignToAccountUuid
      ) {
        ...ChatDetails
      }
    }

    ${CHAT_DETAILS_FRAGMENT.query}
  `,
  parse: boundary({
    updateChatState: CHAT_DETAILS_FRAGMENT.parse,
  }),
};

export const RESET_UNREAD_COUNTER = gql`
  mutation resetUnreadCounter($numberUuid: ID!, $chatUuid: ID!) {
    resetUnreadCounter(numberUuid: $numberUuid, chatUuid: $chatUuid) {
      ...ChatDetails
    }
  }

  ${CHAT_DETAILS_FRAGMENT.query}
`;
